export default "\r\n   <!-- <div style=\"padding:15px\"> \r\n    <app-navbar></app-navbar>\r\n    </div> -->\r\n    <router-outlet></router-outlet>";